import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import './HeaderNav.scss';

const HeaderNav = (
  {
    baseRequestUrl,
    menuItems,
    displayMenuItems,
    logo,
    logoAria,
    Analytics,
  }
) => {
  const displayMenuItem = (cta) => {
    const { label, url, name } = cta;
    if (!label || displayMenuItems[name] === false) return null;

    return (
      <li
        key={label}
        className="HeaderNav__link-item"
      >
        <Link
          href={url}
          className="HeaderNav__link"
          onClick={() => {
            const extraParam = {
              action_name: 'Menu - Click',
              item_name: label,
            };
            handleMktAnalytics(Analytics.event, CTA_EVENT_NAME, extraParam);
          }}
        >
          {label}
        </Link>
      </li>
    );
  };

  return (
    <nav
      aria-label="Main navigation"
      className="HeaderNav__nav"
    >
      <div className="container">
        <div className="HeaderNav__wrapper">
          <div className="HeaderNav__logo">
            {logo && (
              <img src={`${baseRequestUrl}AmexGDAB2B/logos/${logo}`} alt={logoAria} />
            )}
          </div>
          <ul className="HeaderNav__links">
            {menuItems?.map((link) => (
              displayMenuItem(link)
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

HeaderNav.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  displayMenuItems: PropTypes.shape({}).isRequired,
  logo: PropTypes.string.isRequired,
  logoAria: PropTypes.string.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default HeaderNav;
